import { observable, action, flow, toJS, computed } from 'mobx';
import { Toast, Modal } from 'antd-mobile';
import utils from 'utils';
import Serv from './ApplyAfterSaleServ';
import Stores from 'config/Stores';
const defaultListData = {
  data: null,
  isLoading: false,
  hasPullToRefresh: true,
  pageNum: 1,
  pages: 1
};

class ApplyAfterSaleMod {
  // 代客卡号
  @observable dgCardCode = '';

  // 代客Id
  @observable dgUserId = '';

  @observable type = '';

  @observable secondType = '';

  @observable orderListData = defaultListData;

  // 已选订单编号列表
  @observable selectedOrderNos = [];

  @observable orderPageTab = 0;

  @observable selectedOrderList = [];

  // 这是A商品列表换货成B商品列表时，B的列表（无理由换货才有）
  @observable confirmedProductList = [];

  @observable submitList = [];

  @observable desc = '';

  @observable imgList = [];

  // 批次号，中间逗号隔开
  @observable batchNo = '';

  @observable addressInfo = {};

  // 是否能够操作子商品的标识（质量问题103、货损问题101的换货，type=1）
  @observable isChildCanHandle = false;

  // 外箱6张照片
  @observable boxImgList = [];

  @observable tradeInfo = {};

  // @observable showQuesModal = false;

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @computed
  totalOrder() {
    let data = {
      orderCount: this.selectedOrderList.length,
      productCount: 0,
      totalAmount: 0,
      totalBv: 0
    };
    this.selectedOrderList.forEach((order) => {
      data.totalAmount += order.totalAmount;
      data.productCount += order.listData.length;
      data.totalBv += order.bv;
    });
    return data;
  }

  getOrderList = flow(function* (pageNum = 1, keyword, userId = '') {
    const { orderListData, type, secondType } = this;
    this.orderListData.isLoading = true;

    const params = {
      pageSize: 10,
      pageNum,
      type,
      secondType,
      tradeNo: keyword,
      userId,
      applyType: userId ? 1 : 0
    };

    try {
      const { data } = yield Serv.getOrderList(params);

      this.orderListData.isLoading = false;
      if (params.pageNum !== 1) {
        const arr = orderListData.data || [];
        this.orderListData.data = arr.concat(data.list || []);
      } else {
        this.orderListData.data = data.list || [];
      }
      // 重置页数等信息
      this.orderListData.pageNum = data.pageNum;
      this.orderListData.pages = data.pages;
    } catch (e) {
      this.orderListData.isLoading = false;
    }
  });

  /**
   * 换货：质量问题，只能选单个订单，单个商品
   * 维修：都单个订单，单个商品
   * 退货：单个订单，所有商品
   * 多选订单最多10笔，有同订单类型和配货比例限制
   */
  @action
  selectOrders(tradeNo, type) {
    const findIndex = this.selectedOrderNos.indexOf(tradeNo);
    if (findIndex >= 0) {
      this.selectedOrderNos.splice(findIndex, 1);
    } else {
      if ((this.type == 1 && this.secondType != '103') || this.type == 3) {
        if (this.selectedOrderNos.length >= 10) {
          Toast.info('最多只能选择10笔订单进行售后', 2);
        } else {
          this.selectedOrderNos.push(tradeNo);
        }
      } else if (+type === 3) {
        this.selectedOrderNos.push(tradeNo);
      } else {
        this.selectedOrderNos = [tradeNo];
      }
    }
  }

  getProductList = flow(function* (pageNum = 1, index) {
    const tabIndex = index || this.orderPageTab;
    const params = {
      pageSize: 100,
      pageNum,
      tradeNo: this.selectedOrderList[tabIndex].tradeNo
    };

    if (!this.selectedOrderList[tabIndex].listData) {
      this.selectedOrderList[tabIndex].listData = defaultListData;
    }
    let listData = { ...this.selectedOrderList[tabIndex].listData };

    try {
      listData.isLoading = true;
      this.selectedOrderList[tabIndex].listData = listData;

      if (pageNum == 1 && (index === 0 || index === undefined)) {
        Toast.loading('请稍候', 100);
      }

      const { data } = yield Serv.getProductList(params);

      Toast.hide();

      listData.isLoading = false;
      this.selectedOrderList[tabIndex].listData = listData;

      // 处理每一件子商品对象 - 拼接orderItemId（子产品在订单中的id）和parentOrderItemId（父产品在订单中的id）
      let list = data.list || [];
      list = list.map((item) => {
        item.orderItemId = item.id;

        // 一级商品添加最大的申请数量
        item.maxNum = item.itemNum;

        // 回显一级商品的申请数量
        const selectedGoodsArr = this.selectedOrderList[tabIndex].selectedGoodsArr || [];
        const findPIdx = selectedGoodsArr.findIndex(
          (goods) => goods.itemSerial == item.itemSerial && !goods.parentOrderItemId
        );
        if (findPIdx > -1) {
          item.itemNum = selectedGoodsArr[findPIdx].itemNum || item.itemNum;
        }

        // 遍历子商品，添加字段
        item.child &&
          item.child.map((cItem) => {
            cItem.orderItemId = cItem.id;
            cItem.parentOrderItemId = item.id;

            // 子商品添加最大的申请数量
            cItem.maxNum = cItem.itemNum * item.itemNum;

            // 如果子商品不能操作，则itemNum保持不变，在view层会乘以父商品的数量

            // 如果子商品能够操作数量（即质量问题、货损的换货）
            if (this.isChildCanHandle) {
              // 子商品的申请数量默认为最大值
              cItem.itemNum = cItem.maxNum;

              // 回显子商品的申请数量
              const findCIdx = selectedGoodsArr.findIndex(
                (goods) => goods.itemSerial == cItem.itemSerial && !!goods.parentOrderItemId
              );
              if (findCIdx > -1) {
                cItem.itemNum = selectedGoodsArr[findCIdx].itemNum || item.itemNum;
              }
            }
          });

        return item;
      });

      if (params.pageNum !== 1) {
        const arr = listData.data || [];
        listData.data = arr.concat(list);
      } else {
        listData.data = list;
      }

      this.selectedOrderList[tabIndex].total = data.total;

      // 重置页数等信息
      listData.pageNum = data.pageNum;
      listData.pages = data.pages;
    } catch (e) {
      console.log('ApplyAfterSaleMod getProductList e = ', e);
      listData.isLoading = false;
    }

    this.selectedOrderList[tabIndex].listData = listData;
  });

  /**
   * 20210413，该方法已弃用，选中商品的方法，用selectGoods
   * 换货：质量问题，只能选单个订单，单个商品
   * 维修：都单个订单，单个商品
   * 退货：单个订单，所有商品（置灰）
   */
  @action
  selectProducts(itemId) {
    const { selectedOrderList, orderPageTab } = this;
    let selectedProductIds = selectedOrderList[orderPageTab].selectedProductIds || [];
    const findIndex = selectedProductIds.indexOf(itemId);
    if (findIndex >= 0) {
      selectedProductIds.splice(findIndex, 1);
    } else {
      if ((this.type == 1 && this.secondType == '103') || this.type == 2) {
        selectedProductIds = [itemId];
      } else {
        selectedProductIds.push(itemId);
      }
    }
    selectedOrderList[orderPageTab].selectedProductIds = selectedProductIds;
    this.selectedOrderList = toJS(selectedOrderList);
  }

  /**
   * 退货默认选中所有的产品
   */
  @action
  selectAllGoods = () => {
    const { selectedOrderList, orderPageTab } = this;

    selectedOrderList.forEach((item, index) => {
      // 当前订单中，已选中的商品数组
      const selectedGoodsArr = item.selectedGoodsArr || [];

      // 当前订单的商品数组
      const prodArr = item.listData.data || [];

      selectedGoodsArr.push(...prodArr);

      // 重新赋值
      item.selectedGoodsArr = selectedGoodsArr || [];
    });
  };

  /**
   * 点击 选中 或 取否
   * pIdx 一级商品/组合商品 的索引
   * cIdx 子商品在组合商品内的索引
   */
  @action
  selectGoods(pIdx, cIdx = null) {
    const { selectedOrderList, orderPageTab } = this;

    // 当前订单中，已选中的商品数组
    const selectedGoodsArr = selectedOrderList[orderPageTab].selectedGoodsArr || [];

    // 当前订单的商品数组
    const prodArr = selectedOrderList[orderPageTab].listData.data || [];

    if (cIdx != null) {
      // 当前点击的商品，是子商品
      const findCIdx = selectedGoodsArr.findIndex(
        (goods) =>
          goods.itemSerial == prodArr[pIdx].child[cIdx].itemSerial && !!goods.parentOrderItemId
      );

      if (findCIdx > -1) {
        selectedGoodsArr.splice(findCIdx, 1);
      } else {
        selectedGoodsArr.push(prodArr[pIdx].child[cIdx]);
      }
    } else {
      // 当前点击的商品，是一级商品
      const findPIdx = selectedGoodsArr.findIndex(
        (goods) => goods.itemSerial == prodArr[pIdx].itemSerial && !goods.parentOrderItemId
      );

      if (findPIdx > -1) {
        selectedGoodsArr.splice(findPIdx, 1);
      } else {
        selectedGoodsArr.push(prodArr[pIdx]);
      }
    }

    // 重新赋值
    selectedOrderList[orderPageTab].selectedGoodsArr = selectedGoodsArr || [];
  }

  /**
   * 修改商品的数量
   * pIdx 一级商品/组合商品 的索引
   * cIdx 子商品在组合商品内的索引
   * itemNum 数量
   */
  @action
  changeGoodsNum(pIdx, cIdx = null, itemNum) {
    const { selectedOrderList, orderPageTab } = this;

    // 当前订单中，已选中的商品数组
    let selectedGoodsArr = selectedOrderList[orderPageTab].selectedGoodsArr || [];
    selectedGoodsArr = JSON.parse(JSON.stringify(selectedGoodsArr));

    // 当前订单的商品数组
    let prodArr = selectedOrderList[orderPageTab].listData.data || [];
    prodArr = JSON.parse(JSON.stringify(prodArr));

    if (cIdx != null) {
      // 当前点击的商品，是子商品
      const findCIdx = selectedGoodsArr.findIndex(
        (goods) =>
          goods.itemSerial == prodArr[pIdx].child[cIdx].itemSerial && !!goods.parentOrderItemId
      );

      prodArr[pIdx].child[cIdx].itemNum = itemNum || 1;

      if (findCIdx > -1) {
        selectedGoodsArr[findCIdx].itemNum = itemNum || 1;
      }
    } else {
      // 当前点击的商品，是一级商品
      const findPIdx = selectedGoodsArr.findIndex(
        (goods) => goods.itemSerial == prodArr[pIdx].itemSerial && !goods.parentOrderItemId
      );

      prodArr[pIdx].itemNum = itemNum || 1;

      if (findPIdx > -1) {
        selectedGoodsArr[findPIdx].itemNum = itemNum || 1;
      }
    }

    // 赋值
    selectedOrderList[orderPageTab].listData.data = prodArr || [];

    selectedOrderList[orderPageTab].selectedGoodsArr = selectedGoodsArr || [];
  }

  handleAddress(data) {
    const { province = '', city = '', district = '', street = '', detailAddr = '' } = data;

    // 只返回“详细地址”即可，无需拼接
    return `${detailAddr || ''}`;
    // return `${province || ''}${city || ''}${district || ''}${street || ''}${detailAddr || ''}`;
  }

  /**
   * 获取地址
   */
  getAddress = flow(function* () {
    // 当已经有了地址，则不需要再请求
    if (this.addressInfo.detailed) {
      return;
    }

    const params = {
      // deliveryType: this.type,
      deliveryType: 1,
      memberCard: this.dgCardCode
    };
    // const params = {
    //   pageSize: 1,
    //   pageNum: 1,
    // };
    try {
      const { data } = yield Serv.getAddress(params);

      if (data && data.userAddressList && data.userAddressList.length > 0) {
        this.addressInfo = {
          ...data.userAddressList[0],
          detailed: this.handleAddress(data.userAddressList[0])
        };

        // 处理默认地址选择
        this.handleArea();
      }
    } catch (e) {}
    // try {
    //   const { data } = yield Serv.getAddressList(params);
    //   if (data && data.list && data.list.length > 0) {
    //     this.addressInfo = {
    //       ...data.list[0],
    //       detailed: this.handleAddress(data.list[0]),
    //     };
    //   }
    // } catch (e) {}
  });

  /**
   * 处理默认地址选择
   */
  handleArea = () => {
    const tmpArr = [];
    const arr = ['province', 'city', 'district', 'street'];

    arr.forEach((item) => {
      const name = `${item}`;
      const code = `${item}Code`;

      if (this.addressInfo[code] && this.addressInfo[name]) {
        tmpArr.push({
          label: this.addressInfo[name],
          value: this.addressInfo[code]
        });
      }
    });

    this.addressInfo.area = tmpArr;
  };

  /**
   * 退货交验，已发货的弹出弹窗提醒
   */
  checkOrderReturn = flow(function* (tradeNoList = []) {
    try {
      const { data, resultCode } = yield Serv.checkOrderReturn(tradeNoList);
      if (resultCode == '0') {
        return data || [];
      }
      return [];
    } catch (error) {
      return [];
    }
  });

  /**
   * 申请售后
   */
  submit = flow(function* (cardCode = '') {
    // 如果是货损缺件的换货，则额外判断图片
    if (this.type == 1 && this.secondType == '101') {
      if (this.imgList.length == 0) {
        return Toast.fail('请上传至少1张商品图片');
      }
      if (this.boxImgList.length != 6) {
        return Toast.fail('请上传6张外箱照片');
      }
    }

    let params = {
      type: this.type,
      secondType: this.secondType,
      applyType: cardCode ? 1 : 0, // 售后申请类型（0 自主售后，1代客售后）
      imgUrl: this.imgList.join(','), // 附件图片，逗号分割
      remark: this.desc,
      selectedOrderReqDtoList: this.submitList,
      // 被代理人会员卡号
      memberCard: cardCode,
      boxImgUrl: this.boxImgList.join(',') // 外箱照片，逗号分割
    };

    // 当不是撤单（type=3）时，需要传递收货信息
    if (this.type != 3) {
      let { contact, phone, detailed, area, id } = this.addressInfo;
      if (!utils.trim(contact)) return Toast.fail('收件人不能为空');
      if (!utils.checkInput(phone, 'mobile')) return Toast.fail('联系电话不合法');
      if (!utils.trim(detailed)) return Toast.fail('详细地址不能为空');
      contact = utils.getStrictName(contact);
      if (!contact) return;

      // 添加收货信息到参数
      params.deliveryAddress = detailed;
      params.deliveryMobile = phone;
      params.deliveryName = contact;
      params.deliveryId = id;

      // 省市区三级地址入参
      if (!area.length) return Toast.fail('请选择所在地区');
      // 注意此处的入参，区是area，而不是district
      const arr = ['province', 'city', 'area'];
      area.forEach((item, idx) => {
        params[`${arr[idx]}Name`] = item.label || '';
        params[`${arr[idx]}Code`] = item.value || '';
      });
    }

    // 是否无理由的换货
    const isNoReasonExchange = this.type == 1 && this.secondType == 102;
    if (isNoReasonExchange) {
      // 要换成目标商品的数据处理成后端需要的字段
      params.itemDtoList = this.confirmedProductList.map((item) => ({
        bv: item.bv,
        itemCode: item.code,
        itemName: item.name,
        itemNum: item.count,
        itemPrice: item.price,
        itemSerial: item.id,
        skuSerial: item.skuId
      }));
    }

    if (this.type == 2 || (this.type == 1 && this.secondType == '103')) {
      this.batchNo = this.batchNo.replace('，', ',');
      if (!`${this.batchNo}`) {
        Toast.info('请输入批次号~');
        return;
      }
      if (!utils.checkInput(this.batchNo.replace(',', ''), 'account')) {
        Toast.info('批次号请输入数字或英文~');
        return;
      }
      params.itemsBatchNo = this.batchNo;
    }

    // forLog
    // console.log('ApplyAfterSaleMod - params = ' + JSON.stringify(params));
    // return;

    try {
      Toast.loading('请稍候', 100);

      const { data } = yield Serv.applyAfterSale(params);

      Toast.hide();
      Toast.success('提交售后成功', 2);
      window.sensors.track('afterSale', {
        type: ['', '换货', '维修', '退货'][+this.type]
      });
      if (data) {
        // this.tradeInfo=data.afterSaleNo ||''
        // Stores.AppMod.changeState('associatedTradeNos',data[0].afterSaleNo ||'')
        // Stores.AppMod.changeState('tradeNo',data[0].tradeNo ||'')
      }
      // Stores.AppMod.changeState('showQuesModal',true)
      // // let that =this;
      // // Stores.AppMod.getSatisfiedInfo(3).then((res)=>{
      // //   // this.showQuesModal = true;
      // // })
      // Stores.AppMod.getSatisfiedInfo(3).then(res => {
      //   // this.showQuesModal = true;

      // });
      window.app.router.goBack(-4);

      // 神策数据发送
    } catch (error) {
      console.log('e0000000', error);
    }
  });

  @action
  resetData() {
    this.type = '';
    this.secondType = '';
    this.orderListData = defaultListData;
    this.selectedOrderNos = [];
    this.productListData = defaultListData;
    this.submitList = [];
    this.desc = '';
    this.boxImgList = [];
    this.imgList = [];
    this.batchNo = '';
    this.addressInfo = {};
  }
}

const applyAfterSaleMod = new ApplyAfterSaleMod();
export default applyAfterSaleMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ApplyAfterSaleMod.js